import { BaseUrl } from "@/lib/shared/constants";

export const BRAND_SHARE_TAG = "tutulyjewellery";

function withHashTag(tag: string): string {
  return tag.startsWith("#") ? tag : `#${tag}`;
}

export function buildProductShareUrl(locale: string, sku: string): string {
  return `${BaseUrl}/${locale}/products/${sku}`;
}

export function buildProductShareHashtags(sku: string, extraTags: string[] = []): string[] {
  return [sku, BRAND_SHARE_TAG, ...extraTags];
}

export function getPrimaryShareTag(hashtags: string[]): string | undefined {
  const [first] = hashtags;
  return first ? withHashTag(first) : undefined;
}
